module.exports = __webpack_public_path__ + "img/bg-induce-m-01.ff2d5aad.png";